import { cn } from './cn';

/*
  CapacityBar — ёмкость/доля. Нейтральна, окрашивается только при пороге (грамматика §4.6):
  до warn — fg-muted на muted-дорожке, warn — warning, danger — danger.
*/

interface CapacityBarProps {
  value: number; // 0–100
  warn?: number;
  danger?: number;
  label?: string;
  detail?: string;
  className?: string;
}

export function CapacityBar({ value, warn = 75, danger = 90, label, detail, className }: CapacityBarProps) {
  const v = Math.max(0, Math.min(100, value));
  const tone = v >= danger ? 'bg-danger' : v >= warn ? 'bg-warning' : 'bg-fg-muted';
  return (
    <div data-slot="capacity" className={cn('flex flex-col gap-1.5', className)}>
      {(label || detail) && (
        <div className="flex items-baseline justify-between gap-2 text-xs">
          {label && <span className="font-medium text-fg-muted">{label}</span>}
          {detail && <span className="text-fg-subtle tabular-nums">{detail}</span>}
        </div>
      )}
      <div
        className="h-1.5 w-full overflow-hidden rounded-full bg-muted"
        role="meter"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={v}
        aria-label={label}
      >
        <div
          className={cn('h-full rounded-full transition-all duration-smooth ease-standard', tone)}
          style={{ width: `${v}%` }}
        />
      </div>
    </div>
  );
}
